export default __webpack_public_path__ + "static/media/latest-drops-2.3c5b329f.png";